import React, { useState } from 'react';
import { FaFileAlt, FaSearch, FaCheck, FaClipboardCheck } from 'react-icons/fa';

const RequestTracker = () => {
        const [searchTerm, setSearchTerm] = useState('');
        const [requests] = useState([
                {
                        id: '1',
                        requestDate: '30/10/2024',
                        requestType: 'Clinical Notes',
                        salutation: 'Mr.',
                        patientName: 'Peter Campbell',
                        dob: '10/11/1950',
                        collated: false,
                        hasCheck: true,
                        collatedBy: 'Ginky',
                        requester: 'Eisterwick Medical Centre',
                        contact: 'Dr David Bother',
                        reference: '',
                        emailTo: 'esterwickreception@medcentre...'
                },
                {
                        id: '2',
                        requestDate: '30/10/2024',
                        requestType: 'Clinical Notes',
                        salutation: 'Mr.',
                        patientName: 'Carl Saes',
                        dob: '25/07/1969',
                        collated: false,
                        hasCheck: true,
                        collatedBy: 'Ginky',
                        requester: 'Arnold Thomas & Becker',
                        contact: 'Don Maffia',
                        reference: 'DMABAN 325280',
                        emailTo: 'barsael@arnoldthomasbecker.com...'
                }
        ]);

        return (
                <div className="p-6">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-6">
                                <h1 className="text-2xl font-bold text-base-content flex items-center gap-3">
                                        <FaClipboardCheck className="text-primary" />
                                        Medical Report & Clinical Notes Requests
                                </h1>
                        </div>

                        {/* Search and Filters */}
                        <div className="mb-6 flex justify-between items-center">
                                <div className="relative">
                                        <input
                                                type="text"
                                                placeholder="Search requests..."
                                                className="input input-bordered w-64 pl-10"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-base-content opacity-60" />
                                </div>
                                <button className="btn btn-ghost btn-sm">
                                        Clear filters
                                </button>
                        </div>

                        {/* Table */}
                        <div className="bg-base-100 rounded-lg shadow">
                                <table className="table w-full text-left text-sm border">
                                        <thead className="text-xs uppercase">
                                                <tr>
                                                        <th className="px-6 py-3">REQUEST DATE</th>
                                                        <th className="px-6 py-3">REQUEST TYPE</th>
                                                        <th className="px-6 py-3">SALUTATION</th>
                                                        <th className="px-6 py-3">PATIENT NAME</th>
                                                        <th className="px-6 py-3">DOB</th>
                                                        <th className="px-6 py-3">COLLATED?</th>
                                                        <th className="px-6 py-3"></th>
                                                        <th className="px-6 py-3">COLLATED BY</th>
                                                        <th className="px-6 py-3">REQUESTER</th>
                                                        <th className="px-6 py-3">CONTACT</th>
                                                        <th className="px-6 py-3">REFERENCE #</th>
                                                        <th className="px-6 py-3">EMAIL FILE TO</th>
                                                </tr>
                                        </thead>
                                        <tbody>
                                                {requests.map((request) => (
                                                        <tr key={request.id} className="hover">
                                                                <td>{request.requestDate}</td>
                                                                <td>
                                                                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                                                                                {request.requestType}
                                                                        </span>
                                                                </td>
                                                                <td>{request.salutation}</td>
                                                                <td>{request.patientName}</td>
                                                                <td>{request.dob}</td>
                                                                <td>
                                                                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">
                                                                                No
                                                                        </span>
                                                                </td>
                                                                <td>
                                                                        {request.hasCheck && <FaCheck className="text-green-500" />}
                                                                </td>
                                                                <td>
                                                                        {request.collatedBy && (
                                                                                <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                                                                                        {request.collatedBy}
                                                                                </span>
                                                                        )}
                                                                </td>
                                                                <td>{request.requester}</td>
                                                                <td>{request.contact}</td>
                                                                <td>{request.reference}</td>
                                                                <td>{request.emailTo}</td>
                                                        </tr>
                                                ))}
                                        </tbody>
                                </table>
                        </div>
                </div>
        );
};

export default RequestTracker;